export const SET_SCHEDULE_MEETINGS = "SET_SCHEDULE_MEETINGS";
export const SET_MEETINGS_HELD = "SET_MEETINGS_HELD";
export const SET_UPCOMING_MEETINGS = "SET_UPCOMING_MEETINGS";
export const SET_DELIBERATIVE = "SET_DELIBERATIVE";
